import {environment} from '../../environments/environment';

export const LEGEND = [
  {
    year: '2018',
    legend: [
      {
        label: "Grassland",
        color: "#8EFF26"
      },
      {
        label: "Maize",
        color: "#FFF826"
      },
      {
        label: "Winter wheat",
        color: "#FFA311"
      },
      {
        label: "Winter barley",
        color: "#94B93C"
      },
      {
        label: "Potato",
        color: "#9F480F"
      },
      {
        label: "Beet",
        color: "#21767E"
      },
      {
        label: "Fruit trees",
        color: "#7D1E8A"
      },
      {
        label: "Other arable",
        color: "#818E99"
      }
    ]
  },
  {
    year: '2019',
    legend: [
      {
        label: "Grassland",
        color: "#8EFF26"
      },
      {
        label: "Maize",
        color: "#FFF826"
      },
      {
        label: "Winter wheat",
        color: "#FFA311"
      },
      {
        label: "Winter barley",
        color: "#94B93C"
      },
      {
        label: "Potato",
        color: "#9F480F"
      },
      {
        label: "Beet",
        color: "#21767E"
      },
      {
        label: "Flax",
        color: "#64d4da"
      },
      {
        label: "Rapeseed",
        color: "#d08c9f"
      },
      {
        label: "Fruit trees",
        color: "#7D1E8A"
      },
      {
        label: "Other arable",
        color: "#818E99"
      },
    ]
  },
  {
    year: '2020',
    legend: [
      {
        label: "Grassland",
        color: "#8EFF26"
      },
      {
        label: "Maize",
        color: "#FFF826"
      },
      {
        label: "Winter wheat",
        color: "#FFA311"
      },
      {
        label: "Winter barley",
        color: "#94B93C"
      },
      {
        label: "Potato",
        color: "#9F480F"
      },
      {
        label: "Beet",
        color: "#21767E"
      },
      {
        label: "Flax",
        color: "#64d4da"
      },
      {
        label: "Rapeseed",
        color: "#d08c9f"
      },
      {
        label: "Fruit trees",
        color: "#7D1E8A"
      },
      {
        label: "Other arable",
        color: "#818E99"
      },
    ]
  }

];






// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/src/app/config/legend.config.ts